export default __webpack_public_path__ + "static/media/374.cd52b40e.png";